export class PlayerSettingsDto {
    playerId: number;
    tacticNumber: number;
    passType: number;
    attackHelp: number;
    defenceHelp: number;
    standardAtttack: number;
    standardDefence: number;
    longShots: number;
    dribbling: number;
    cutPass: number;
    offside: number;
    freeRole: number;
    markPlayerId: number;
}